/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Box, Typography } from '@mui/material';

export const Badge = (props) => {
  return (
    <Box
      sx={{
        bgcolor: props.bgcolor,
        width: props.width,
        px: 2,
        borderRadius: '5px',
        textAlign: 'center',
      }}
    >
      <Typography sx={{ fontWeight: 600 }} variant="overline">
        {props.title}
      </Typography>
    </Box>
  );
};
